export enum RoutingID {
  requirements = 'requirements',
  requirementEdit = 'requirement-edit',
  requirementCreate = 'requirement-create',
  requirementBookingAssignment = 'requirement-booking-assignment',
  reservations = 'reservations',
  filters = 'filters',
  filterEdit = 'filter-edit',
  filterCreate = 'filter-create',
  filterDetails = 'filter-details',
  home = 'home',
  campaignTypes = 'campaign-types',
  campaignTypeDetails = 'campaign-type-details',
  campaignTypeEdit = 'campaign-type-edit',
  campaignTypeCreate = 'campaign-type-create',
  campaigns = 'management',
  campaignCreate = 'campaign-create',
  campaignEdit = 'campaign-edit',
  commercials = 'commercials',
  commercialsEdit = 'commercialsEdit',
  commercialsCreate = 'commercialsCreate',
  plannings = 'plannings',
  planning = 'planning',
  planningView = 'planning-view',
  planningEdit = 'planning-edit',
  planningCreate = 'planning-create',
  admin = 'admin',
  adminOverview = 'admin-overview',
  adminUserManagement = 'admin-users',
  adminClientManagement = 'admin-clients',
  adminClientManagementEdit = 'admin-clients-edit',
  adminClientManagementCreate = 'admin-clients-create',
  adminClientLicences = 'admin-client-licences',
  inventoryOverview = 'inventory-overview',
  infrastructure = 'infrastructure',
  network = 'network',
  mediumExplorer = 'medium-explorer',
  mediumGroup = 'medium-groups',
  mediumGroupEdit = 'medium-group-edit',
  mediumGroupCreate = 'medium-group-create',
  assignment = 'assignment',
  media = 'media',
  offerings = 'offerings',
  products = 'products',
  productEdit = 'product-edit',
  productCreate = 'product-create',
  productDetails = 'product-details',
  productDetailsOverview = 'product-overview',
  productDetailsAttributes = 'product-attributes',
  productDetailsCategories = 'product-categories',
  productCategories = 'productCategories',
  productCategoryEdit = 'productCategories-edit',
  productCategoryCreate = 'productCategories-create',
  areaCategories = 'areaCategories',
  areaCategoryEdit = 'areaCategories-edit',
  areaCategoryCreate = 'areaCategories-create',
  areas = 'areas',
  areaEdit = 'area-edit',
  areaCreate = 'area-create',
  attributes = 'attributes',
  attributeEdit = 'attribute-edit',
  attributeCreate = 'attribute-create',
  companies = 'companies',
  companyLevel = 'company-levels',
  companyEdit = 'company-edit',
  companyCreate = 'company-create',
  companyDetails = 'company-details',
  companyDetailsOverview = 'company-details-overview',
  companyDetailsAttributes = 'company-details-attributes',
  companyDetailsLocations = 'company-details-locations',
  companyDetailsCampaigns = 'company-details-campaigns',
  companyDetailsMedia = 'company-details-media',
  companyDetailsMediumgroups = 'company-details-mediumgroups',
  companyDetailsAreas = 'company-details-areas',
  companyDetailsCulls = 'company-details-culls',
  masterData = 'masterdata',
  datasetContent = 'dataset-content',
  datasetNetwork = 'dataset-network',
  applicationData = 'applicationdata',
  tags = 'tags',
  tagDetails = 'tag-details',
  tagEdit = 'tag-edit',
  tagCreate = 'tag-create',
  channels = 'channels',
  channelDetails = 'channel-details',
  channelDetailsOverview = 'channel-details-overview',
  channelDetailsMarker = 'channel-details-marker',
  channelDetailsDevices = 'channel-details-devices',
  devices = 'devices',
  deviceDetails = 'device-details',
  deviceDetailsOverview = 'device-details-overview',
  deviceDetailsAttributes = 'device-details-attributes',
  deviceDetailsActivity = 'device-details-activity',
  deviceDetailsPlayouts = 'device-details-playouts',
  deviceDetailsPositions = 'device-details-positions',
  deviceDetailsLog = 'device-details-log',
  deviceDetailsGeoStats = 'device-details-geoStats',
  deviceDetailsScreens = 'device-details-screens',
  deviceDetailsPlaylist = 'device-details-playlist',
  deviceDetailsSetlist = 'device-details-setlist',
  deviceDetailsPlaybackSchedule = 'device-details-playback-schedule',
  deviceDetailsContentShare = 'device-details-content-share',
  deviceHardwareCreate = 'player-hardware-create',
  deviceHardwareEdit = 'player-hardware-edit',
  deviceSoftwareCreate = 'player-software-create',
  deviceSoftwareEdit = 'player-software-edit',
  locations = 'locations',
  locationEdit = 'location-edit',
  locationCreate = 'location-create',
  locationDetails = 'location-details',
  locationDetailsOverview = 'location-details-overview',
  locationDetailsStatisticsVisitor = 'location-details-statistics-visitor',
  locationDetailsDevices = 'location-details-devices',
  locationDetailsSettings = 'location-details-settings',
  locationDetailsViews = 'location-details-views',
  locationDetailsThreeDimensionalView = 'location-details-three-dimensional-view',
  pools = 'pools',
  poolDetails = 'pool-details',
  poolEdit = 'pool-edit',
  poolCreate = 'pool-create',
  approval = 'approval',
  networkAllocation = 'network-allocation',
  schedules = 'schedules',
  scheduleDetails = 'schedule-details',
  scheduleEdit = 'schedule-edit',
  scheduleCreate = 'schedule-create',
  networkShare = 'networkShare',
  networkShareEdit = 'networkShare-edit',
  networkShareCreate = 'networkShare-create',
  verification = 'verification',
  shareOfVoice = 'share-of-voice',
  advertiserShareOfVoice = 'advertiser-share-of-voice',
  publisherShareOfVoice = 'publisher-share-of-voice',
  reporting = 'reporting',
  datasets = 'datasets',
  content = 'content',
  templateGroup = 'template-group',
  rulesAndVerification = 'rules-and-verification',
  contentReporting = 'content-reporting',
  playerReporting = 'player-reporting',
  locationReporting = 'location-reporting',
  airtimeReporting = 'airtime-reporting',
  networkReporting = 'network-reporting',
  client = 'client',
  clientOverview = 'client-overview',
  clientInvitations = 'client-invitations',
  clientUserManagement = 'client-user-management',
  clientUserCreate = 'client-user-create',
  clientUserEdit = 'client-user-edit',
  clientSettings = 'client-settings',
  clientRoleManagement = 'client-roles',
  clientConnections = 'client-connections',
  createClientConnection = 'create-client-connection',
  notification = 'notification',
  user = 'user',
  userOverview = 'user-overview',
  userSecurity = 'user-security',
  userPermissions = 'user-permissions',
  userSettings = 'user-settings',
  userEdit = 'user-edit',
  login = 'login',
  passwordReset = 'passwordReset',
  error = 'error',
  extError = 'error-ext',
  templateGroups = 'templateGroups',
  templateGroupsCreate = 'templateGroups-create',
  templateGroupsEdit = 'templateGroups-edit',
  contentEditor = 'content-editor',
  contentEditorCreate = 'content-editor-create',
  contentEditorEdit = 'content-editor-edit',
  contentEditorCreateContent = 'content-editor-create-content',
  contentEditorEditContent = 'content-editor-edit-content',
  playerHardware = 'player-hardware',
  playerSoftware = 'player-software',
  playerHardwareDetails = 'player-hardware-details',
  playerHardwareOverview = 'player-hardware-overview',
  screenHardware = 'screen-hardware',
  screenHardwareEdit = 'screen-hardware-edit',
  screenHardwareCreate = 'screen-hardware-create',
  templateSources = 'templateSources',
  templateSourceEdit = 'templateSource-edit',
  templateSourceCreate = 'templateSource-create',

  templateSourceEntries = 'templateSourceEntries',
  templateSourceEntryCreate = 'templateSourceEntry-create',
  templateSourceEntryEdit = 'templateSourceEntry-edit',

  templateDatasets = 'templateDatasets',
  templateDatasetEdit = 'templateDataset-edit',
  templateDatasetCreate = 'templateDataset-create',

  templateDatasetEntries = 'templateDatasetEntries',
  templateDatasetEntryCreate = 'templateDatasetEntry-create',
  templateDatasetEntryEdit = 'templateDatasetEntry-edit',

  tracker = 'tracker',
  trackerDetails = 'tracker-details',
  trackerDetailsOverview = 'tracker-details-overview',
  trackerDetailsTrackedVisitors = 'tracker-details-tracked-visitors',
  deals = 'deals',
  sspContracts = 'ssp-contracts',
  ssps = 'ssps',
  locationDetailsTracker = 'locationDetailsTracker',
  locationDetailsTrackerAssignment = 'locationDetailsTrackerAssignment',
  networkBookingsList = 'networkBookingsList',
  cronDefinition = 'cronDefinition',
  timeRange = 'timeRange',
  reportingSetup = 'reportingSetup',
  reportingType = 'reportingType',
  reportingTemplate = 'reportingTemplate',
  standardReporting = 'standardReporting',
  generatedReport = 'generatedReport',

  attachmentExplorer = 'attachment-explorer',
  locationDetailsAttachments = 'locationDetailsAttachments',
  deviceDetailsAttachments = 'deviceDetailsAttachments',
  marketing = 'marketing',
  queryPerformance = 'queryPerformance',
  endpointPerformance = 'endpointPerformance',
  partialPlanning = 'partialPlanning',
  colors = 'colors',
  colorEdit = 'color-edit',
  colorCreate = 'color-create',
  weeklySchedule = 'weeklySchedule',
  weeklyScheduleEdit = 'weeklyScheduleEdit',
  weeklyScheduleCreate = 'weeklyScheduleCreate',

  settings = 'settings',
  repositories = 'repositories',
  assets = 'assets',
  assetExplorer = 'asset-explorer',
  assetCategories = 'asset-categories',
  debug = 'debug',
  debugVersion = 'debug-version',
  cullCategories = 'cull-categories',
  mediumGroupCategories = 'mediumGroupCategories',
  targeting = 'targeting',
  mediumTransformationList = 'mediumTransformationList',
  userMembership = 'userMembership',
  contentShare = 'content-share',
  backgroundWorker = 'backgroundWorker',
  clientApiKeys = 'apiKeys',
  deviceDetailsNetworkAccess = 'deviceDetailsNetworkAccess',
  deviceDetailsNetworkBookings = 'deviceDetailsNetworkBookings',
  networkBookings = 'network-bookings',
  routing = 'routing',
}
